import { render, staticRenderFns } from "./PageGuide.vue?vue&type=template&id=03bc912c&"
import script from "./PageGuide.vue?vue&type=script&lang=js&"
export * from "./PageGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03bc912c')) {
      api.createRecord('03bc912c', component.options)
    } else {
      api.reload('03bc912c', component.options)
    }
    module.hot.accept("./PageGuide.vue?vue&type=template&id=03bc912c&", function () {
      api.rerender('03bc912c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/PageGuide.vue"
export default component.exports